// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type { ErrorBody, FinancialPayouts } from "../../types";
export type ListPayoutsV1QueryParams = {
  start_date: string;
  end_date: string;
  format?: "json" | "csv";
  limit?: number;
  order?: "desc" | "asc";
};

export type ListPayoutsQueryParams = {
  start_date: string;
  end_date: string;
  format?: "json" | "csv";
  limit?: number;
  order?: "desc" | "asc";
};

export class Payouts extends APIResource {
  /**
   * Lists ordered payouts for the merchant profile.
   */
  list(
    merchantCode: string,
    query: ListPayoutsV1QueryParams,
    params?: FetchParams,
  ): APIPromise<FinancialPayouts, ErrorBody> {
    return this._client.get<FinancialPayouts, ErrorBody>({
      path: `/v1.0/merchants/${merchantCode}/payouts`,
      query,
      ...params,
    });
  }

  /**
   * Lists ordered payouts for the merchant profile.
   */
  listDeprecated(
    query: ListPayoutsQueryParams,
    params?: FetchParams,
  ): APIPromise<FinancialPayouts, ErrorBody> {
    return this._client.get<FinancialPayouts, ErrorBody>({
      path: `/v0.1/me/financials/payouts`,
      query,
      ...params,
    });
  }
}
